export const SET_SELECTED_ECR_CATEGORY = 'component-repository/categories/set-selected-category';
export const SET_ECR_CATEGORIES = 'component-repository/categories/set-categories';
